import { Component, ViewChild, AfterViewInit, Input } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MappedPackagingQuantityDto } from '../aggregated-quantities-dialog.component';

@Component({
  selector: 'app-aggregated-quantities-table',
  templateUrl: './aggregated-quantities-table.component.html',
  styleUrls: ['./aggregated-quantities-table.component.scss']
})
export class AggregatedQuantitiesTableComponent implements AfterViewInit {
  @Input() quantities!: MappedPackagingQuantityDto[];
  @Input() idFieldName!: string;

  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns = ['packagingId', 'countryName', 'date', 'quantity'];

  sortingDataAccessor = (item: any, property: any) => {
    switch (property) {
      case 'date': return new Date(item.year, item.month, 1);
      default: return item[property];
    }
  }

  dataSource: MatTableDataSource<MappedPackagingQuantityDto>;

  constructor() {
    this.dataSource = new MatTableDataSource<MappedPackagingQuantityDto>();
  }

  ngAfterViewInit(): void {
    this.dataSource.data = this.quantities;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    this.dataSource.sort = this.sort;
  }

}
